import React from 'react';
import styles from './button.module.css';

export type TButtonVariant = 'contained' | 'text';

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
    color?: string,
    hoverColor?: string,
    variant?: TButtonVariant
    disabled?: boolean,
    onClick?: () => void;
    className?: string;
}

const variantClassMap: Record<TButtonVariant, string> = {
  contained: styles.contained,
  text: styles.textVariant,
};

export function Button({
    children,
    color,
    hoverColor,
    variant = 'contained',
    disabled,
    onClick,
    className,
    ...rest
}: IButtonProps) {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`
                ${styles.button}
                ${className}
                ${variantClassMap[variant]}
            `}
            style={{
                '--button-text-color': color,
                '--button-hover-color': hoverColor,
            } as React.CSSProperties}
            {...rest}
        >
            {children}
        </button>
    )
}
